import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Loading } from '@framework/ui/atoms/Loading';
import { Button } from '@framework/ui/atoms/Button';
import { toast } from 'react-hot-toast';
import { trpcClient } from '@framework/trpcClient';
type Props = {
  currentName: string;
  onClose(): void;
};

export const AnonymousUserNameChange: React.FC<Props> = ({ onClose, currentName }: Props) => {
  const { t } = useTranslation();
  const [processing, setProcessing] = useState<boolean>(false);
  const [name, setName] = useState<string>(currentName);

  const handleAnonymousLogin = async () => {
    if (name === '') return;

    setProcessing(true);
    try {
      await trpcClient.anonymousUser.changeName.mutate({ name });
      onClose();
    } catch (error) {
      toast.error(t('framework.topNav.saveError'));
    } finally {
      setProcessing(false);
    }
  };

  return (
    <GeneralModal
      isOpen={true}
      onClose={onClose}
      title={t('framework.topNav.changeName')}
      submitButton={<></>}
      cancelButton={<></>}
    >
      <div className="flex flex-col items-center justify-center p-4" style={{ width: '600px' }}>
        {processing ? (
          <Loading horizontal={true} message={t('framework.topNav.saving')} />
        ) : (
          <>
            <div className="w-3/4 py-2 text-lg">
              <input
                type="text"
                className="w-full rounded border-2 border-gray-500 px-3 py-2"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>
            <Button color="brand" onClick={handleAnonymousLogin} disabled={name === ''}>
              <div className="px-2">{t('framework.topNav.changeNameSubmit')}</div>
            </Button>
          </>
        )}
      </div>
    </GeneralModal>
  );
};
